module.exports = __webpack_public_path__ + "img/mobile/General/stest@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/General/stest@1x.png
// module id = 193
// module chunks = 0